import React from 'react';

import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

const LEAVE_ROUTER_CONFIG_CONFIRMATION_MODAL_TITLE = 'Leave router configuration?';
const LEAVE_BUTTON_TEXT = 'Leave without saving';
const KEEP_EDITING_BUTTON_TEXT = 'Keep editing';

export default function LeaveRouterConfigConfirmationModal(props: {
  onLeave: () => void;
  onRequestClose: () => void;
}): JSX.Element {
  return (
    <Modal
      title={LEAVE_ROUTER_CONFIG_CONFIRMATION_MODAL_TITLE}
      buttons={[
        {
          text: LEAVE_BUTTON_TEXT,
          onClick: () => {
            props.onLeave();
            props.onRequestClose();
          },
          style: ButtonStyle.TERTIARY_GRAY,
        },
        {text: KEEP_EDITING_BUTTON_TEXT, cancel: true, style: ButtonStyle.SECONDARY},
      ]}
      onRequestClose={props.onRequestClose}
    >
      If you leave, any changes you've made to this router will not be saved.
    </Modal>
  );
}
